// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SalePrice: 'sale-price',
} as const;
